import React from "react";

import { ContentCardCaption } from "../../../content-card/caption";
import { ContentCard } from "../../../content-card";
import { Image } from "../../../image";
import { useIntl } from "react-intl";
import { OPEN_LINK } from "../../../../constants/types/commands";
import { useSendCommand } from "../../../../hooks/use-send-command";

import styles from "./styles.modules.scss";

const getCaption = (author?: string, title?: string) => {
    if (!author && !title) {
        return;
    }

    return {
        author,
        title,
    };
};

export const BlockImage = ({
    id,
    author,
    image,
    imageUrl,
    title,
    fullWidth,
}: InboxArticleImageBlock) => {
    const sendCommand = useSendCommand();

    const { locale: lang } = useIntl();

    const onClick = () =>
        imageUrl && sendCommand(OPEN_LINK, { url: imageUrl, label: title });

    const caption = getCaption(author, title);

    return (
        <div
            className={`block-image ${styles.blockImage} ${
                fullWidth === "yes" ? `full-width ${styles.fullWidth}` : ""
            }`}
        >
            <div className={`card ${styles.card}`}>
                <ContentCard id={id} lang={lang}>
                    <div className={`content ${styles.content}`}>
                        {image && (
                            <div
                                className={`image ${styles.image}`}
                                onClick={onClick}
                            >
                                <Image sources={image} />
                            </div>
                        )}

                        {caption && (
                            <div className={`caption ${styles.caption}`}>
                                <ContentCardCaption
                                    creator={caption.author}
                                    cardId={id}
                                    ctaHidden={true}
                                    title={caption.title}
                                />
                            </div>
                        )}
                    </div>
                </ContentCard>
            </div>
        </div>
    );
};
